





























































































import Vue from 'vue'
import { VueForm, Iterable, Params } from '@/utils/interfaces'
import { required, number, graterThan } from '@/utils/validators'
import { TranslateResult } from 'vue-i18n'
import Autocomplete from '@/components/Autocomplete.vue'
import { getTariffs } from '@/api/Remittances/remittances.api'
import { getAgencies } from '@/api/Agency/agency.api'
import { DeliveryCurrenciesEnum } from '@/utils/interfaces/remittance.interface'

export default Vue.extend({
  components: {
    appAutocomplete: Autocomplete,
  },
  props: {
    type: String,
    multiple: Boolean,
    isEdition: Boolean,
  },
  data() {
    return {
      rules: {
        required: (v: string | number) =>
          required(v) || v === 0 || this.$t('validation.field-required'),
        number: (v: number) =>
          number(v.toString()) || this.$t('validation.must-be-a-number'),
        positive: (v: number) =>
          v >= 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
      },
      crud: {
        agency: this.$store.getters.agency.uuid,
        to_agency: null,
        name: '',
        is_active: true,
        min_amount: 0,
        max_amount: 1,
        delivery_currency: 'USD',
        exchange_rate: '1',
        description: '',
      } as Iterable,
      defaultCrud: {},
      getter: (params?: Params) =>
        getTariffs({
          ...params,
          type: 'AGENCY',
          to_agency__uuid: this.$store.getters.agency.uuid,
        }),
      getAgencies: (params?: Params) =>
        getAgencies({ ...params, not_self: true }),
      currencies: Object.values(DeliveryCurrenciesEnum),
    }
  },
  methods: {
    validate() {
      return (this.$refs.form as VueForm).validate()
    },
    getData() {
      return this.crud
    },
    setData(item: Iterable) {
      if (item) {
        Object.keys(this.crud).forEach(key => {
          this.crud[key] = item[key]
        })
      } else this.crud = JSON.parse(JSON.stringify(this.defaultCrud))
      ;(this.$refs.form as VueForm).resetValidation()
    },
  },
  computed: {
    minimum(): TranslateResult[] {
      const errors: TranslateResult[] = []
      !graterThan(this.crud.min_amount, this.$data.crud.max_amount) ||
        errors.push(
          this.$t('validation.must-be-lower-than', {
            value: this.$t('maximum'),
          }),
        )
      return errors
    },
    maximum(): TranslateResult[] {
      const errors: TranslateResult[] = []
      graterThan(this.crud.max_amount, this.$data.crud.min_amount) ||
        errors.push(
          this.$t('validation.must-be-greater-than', {
            value: this.$t('minimum'),
          }),
        )
      return errors
    },
  },
  created() {
    this.defaultCrud = JSON.parse(JSON.stringify(this.crud))
  },
})
